var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white min-h-screen"},[_c('page-header',{attrs:{"hide_navbar":_vm.hide_navbar}}),_vm._v(" "),_c('section1'),_vm._v(" "),_c('section2'),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }